import React from 'react';
import "../TermsCondition/Terms.css"; // Reusing Terms.css for consistency
import SeoHelmets from '../SeoOptimazation/SeoHelmets';

function PrivacyPolicy({pageName}) {
  return (
    <>
      <SeoHelmets 
        title={`${pageName} - Insight IAS Academy`} 
        description={`Read the ${pageName} of Insight IAS Academy. Understand how we collect, use, and protect your data.`}
      />
      <div className='Terms-background'>
        <div className='Terms-card w-md-70' style={{ padding: '2.5vmax 3.5vmax', display: 'block', backgroundColor: '#fff', borderRadius: '15px' }}>
          
          {/* Header Section */}
          <div style={{ textAlign: 'center', marginBottom: '25px' }}>
            <h2 style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '2vmax', textTransform: 'uppercase', marginBottom: '20px', color: '#000' }}>
              PRIVACY POLICY
            </h2>
          </div>
          
          <div style={{ fontSize: '1.1vmax', lineHeight: '1.8vmax', color: '#000', fontFamily: 'inherit' }}>
            <p style={{ fontWeight: 'bold', margin: '5px 0' }}>Insight Edutech Private Limited</p>
            <p style={{ margin: '5px 0' }}>(Website: insightdelhi.com)</p>
            <p style={{ fontWeight: 'bold', margin: '15px 0 5px 0' }}>Effective Date: 01-01-2026</p>
            
            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 1. INTRODUCTION */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>1. INTRODUCTION</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Insight Edutech Private Limited (“Company”, “we”, “our”, or “us”), having its office at New Delhi, India, operates the website <strong>insightdelhi.com</strong> and provides educational services relating to Civil Services Examination preparation, including UPSC and State PSC coaching programmes, NEET, CUET and UGC-NET examinations.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We are committed to protecting the privacy and personal information of our students, users, visitors, and subscribers. This Privacy Policy explains how we collect, use, process, store, protect, and disclose information obtained through our website, mobile communications, online platforms, and related services.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                By accessing or using our website or services, you agree to the terms of this Privacy Policy.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                If you do not agree with this Privacy Policy, kindly discontinue use of the website and services.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 2. INFORMATION WE COLLECT */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>2. INFORMATION WE COLLECT</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We may collect the following categories of information from users:
              </p>

              {/* (a) Personal Information */}
              <div style={{ margin: '15px 0' }}>
                <p style={{ fontWeight: 'bold', margin: '5px 0' }}>(a) Personal Information</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                  <li style={{ margin: '5px 0' }}>Full name</li>
                  <li style={{ margin: '5px 0' }}>Mobile number</li>
                  <li style={{ margin: '5px 0' }}>Email address</li>
                  <li style={{ margin: '5px 0' }}>Postal address</li>
                  <li style={{ margin: '5px 0' }}>City/State/Country</li>
                  <li style={{ margin: '5px 0' }}>Educational background</li>
                  <li style={{ margin: '5px 0' }}>Examination preferences</li>
                  <li style={{ margin: '5px 0' }}>Identity information voluntarily submitted by users</li>
                </ul>
              </div>

              {/* (b) Account & Course Information */}
              <div style={{ margin: '15px 0' }}>
                <p style={{ fontWeight: 'bold', margin: '5px 0' }}>(b) Account & Course Information</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                  <li style={{ margin: '5px 0' }}>User login credentials</li>
                  <li style={{ margin: '5px 0' }}>Course enrolment details</li>
                  <li style={{ margin: '5px 0' }}>Batch information</li>
                  <li style={{ margin: '5px 0' }}>Attendance/activity records</li>
                  <li style={{ margin: '5px 0' }}>Test performance and progress data</li>
                </ul>
              </div>

              {/* (c) Payment Information */}
              <div style={{ margin: '15px 0' }}>
                <p style={{ fontWeight: 'bold', margin: '5px 0' }}>(c) Payment Information</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                  <li style={{ margin: '5px 0' }}>Transaction details</li>
                  <li style={{ margin: '5px 0' }}>Payment amount</li>
                  <li style={{ margin: '5px 0' }}>Payment mode</li>
                  <li style={{ margin: '5px 0' }}>Limited payment references</li>
                </ul>
                <p style={{ fontWeight: 'bold', margin: '15px 0 5px 0' }}>Note:</p>
                <p style={{ margin: '5px 0', textAlign: 'justify' }}>
                  We do not store complete debit card, credit card, net banking, or UPI credentials on our servers.
                </p>
                <p style={{ margin: '5px 0', textAlign: 'justify' }}>
                  Payments may be processed through authorized third-party payment gateway providers.
                </p>
              </div>

              {/* (d) Technical & Usage Information */}
              <div style={{ margin: '15px 0' }}>
                <p style={{ fontWeight: 'bold', margin: '5px 0' }}>(d) Technical & Usage Information</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                  <li style={{ margin: '5px 0' }}>IP address</li>
                  <li style={{ margin: '5px 0' }}>Browser type</li>
                  <li style={{ margin: '5px 0' }}>Device information</li>
                  <li style={{ margin: '5px 0' }}>Operating system</li>
                  <li style={{ margin: '5px 0' }}>Website usage behaviour</li>
                  <li style={{ margin: '5px 0' }}>Cookies and analytics data</li>
                  <li style={{ margin: '5px 0' }}>Date and time of access</li>
                </ul>
              </div>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 3. HOW WE COLLECT INFORMATION */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>3. HOW WE COLLECT INFORMATION</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Information may be collected when users:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>Visit our website</li>
                <li style={{ margin: '5px 0' }}>Register an account</li>
                <li style={{ margin: '5px 0' }}>Enrol in a course</li>
                <li style={{ margin: '5px 0' }}>Make payment</li>
                <li style={{ margin: '5px 0' }}>Contact us</li>
                <li style={{ margin: '5px 0' }}>Submit forms</li>
                <li style={{ margin: '5px 0' }}>Attend webinars/classes</li>
                <li style={{ margin: '5px 0' }}>Use learning tools or services</li>
                <li style={{ margin: '5px 0' }}>Subscribe to updates or newsletters</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 4. PURPOSE OF COLLECTION AND USE */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>4. PURPOSE OF COLLECTION AND USE</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We may use collected information for the following purposes:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>Course enrolment and delivery</li>
                <li style={{ margin: '5px 0' }}>Student support and communication</li>
                <li style={{ margin: '5px 0' }}>Academic management and mentorship</li>
                <li style={{ margin: '5px 0' }}>Verification of transactions</li>
                <li style={{ margin: '5px 0' }}>Providing study material and updates</li>
                <li style={{ margin: '5px 0' }}>Improving website performance and user experience</li>
                <li style={{ margin: '5px 0' }}>Internal analytics and business operations</li>
                <li style={{ margin: '5px 0' }}>Security monitoring and fraud prevention</li>
                <li style={{ margin: '5px 0' }}>Marketing, promotional communication, and announcements</li>
                <li style={{ margin: '5px 0' }}>Compliance with legal obligations</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 5. CONSENT */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>5. CONSENT</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                By using our website, registering an account, purchasing any course, or submitting information, you expressly consent to the collection, storage, processing, and use of your information in accordance with this Privacy Policy.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users may withdraw consent by contacting us, subject to legal and contractual obligations.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 6. COOKIES AND TRACKING TECHNOLOGIES */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>6. COOKIES AND TRACKING TECHNOLOGIES</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Our website may use cookies and similar technologies to:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>Improve website functionality</li>
                <li style={{ margin: '5px 0' }}>Remember user preferences</li>
                <li style={{ margin: '5px 0' }}>Analyze website traffic</li>
                <li style={{ margin: '5px 0' }}>Enhance browsing experience</li>
                <li style={{ margin: '5px 0' }}>Maintain login sessions</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users may disable cookies through browser settings; however, some website features may not function properly thereafter.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 7. PAYMENT PROCESSING */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>7. PAYMENT PROCESSING</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Payments on the website may be processed through third-party payment gateway providers.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                The Company:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>does not store full card or banking credentials;</li>
                <li style={{ margin: '5px 0' }}>is not responsible for technical failures of third-party payment systems;</li>
                <li style={{ margin: '5px 0' }}>shall not be liable for unauthorized transactions arising from user negligence or external cyber incidents.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users are advised to review the privacy policies of payment gateway providers separately.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 8. USER ACCOUNT RESPONSIBILITY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>8. USER ACCOUNT RESPONSIBILITY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users are responsible for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>maintaining confidentiality of login credentials;</li>
                <li style={{ margin: '5px 0' }}>restricting unauthorized access to their accounts;</li>
                <li style={{ margin: '5px 0' }}>all activities conducted through their accounts.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Sharing of accounts, passwords, or course access with third parties is strictly prohibited. The Company shall not be liable for losses arising from unauthorized access caused by user negligence.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 9. CONTENT PROTECTION & INTELLECTUAL PROPERTY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>9. CONTENT PROTECTION & INTELLECTUAL PROPERTY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                All educational content including:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>recorded lectures,</li>
                <li style={{ margin: '5px 0' }}>live classes,</li>
                <li style={{ margin: '5px 0' }}>notes,</li>
                <li style={{ margin: '5px 0' }}>PDFs,</li>
                <li style={{ margin: '5px 0' }}>test series,</li>
                <li style={{ margin: '5px 0' }}>mentorship material,</li>
                <li style={{ margin: '5px 0' }}>study resources,</li>
                <li style={{ margin: '5px 0' }}>graphics and website content</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                are the exclusive intellectual property of Insight Edutech Private Limited and/or respective faculty members.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users shall not:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>copy,</li>
                <li style={{ margin: '5px 0' }}>reproduce,</li>
                <li style={{ margin: '5px 0' }}>distribute,</li>
                <li style={{ margin: '5px 0' }}>publish,</li>
                <li style={{ margin: '5px 0' }}>upload,</li>
                <li style={{ margin: '5px 0' }}>sell,</li>
                <li style={{ margin: '5px 0' }}>share,</li>
                <li style={{ margin: '5px 0' }}>screen-record,</li>
                <li style={{ margin: '5px 0' }}>or commercially exploit</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                any content without prior written permission.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Violation may result in:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>termination of access,</li>
                <li style={{ margin: '5px 0' }}>civil claims,</li>
                <li style={{ margin: '5px 0' }}>criminal proceedings,</li>
                <li style={{ margin: '5px 0' }}>and recovery of damages.</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 10. SHARING OF INFORMATION */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>10. SHARING OF INFORMATION</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We do not sell or rent personal information to third parties for commercial marketing purposes.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Information may be shared only:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>with authorized employees or faculty;</li>
                <li style={{ margin: '5px 0' }}>with trusted service providers;</li>
                <li style={{ margin: '5px 0' }}>with payment gateway providers;</li>
                <li style={{ margin: '5px 0' }}>with cloud hosting or technical vendors;</li>
                <li style={{ margin: '5px 0' }}>when required by law or government authorities;</li>
                <li style={{ margin: '5px 0' }}>to protect legal rights, security, or prevent fraud.</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 11. DATA SECURITY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>11. DATA SECURITY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We implement reasonable administrative, technical, and security measures to protect user information against:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>unauthorized access,</li>
                <li style={{ margin: '5px 0' }}>misuse,</li>
                <li style={{ margin: '5px 0' }}>alteration,</li>
                <li style={{ margin: '5px 0' }}>disclosure,</li>
                <li style={{ margin: '5px 0' }}>or destruction.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                However, no internet transmission or electronic storage system is completely secure. Users share information at their own risk.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 12. DATA RETENTION */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>12. DATA RETENTION</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We may retain user information:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>for academic and operational purposes;</li>
                <li style={{ margin: '5px 0' }}>for legal compliance;</li>
                <li style={{ margin: '5px 0' }}>for dispute resolution;</li>
                <li style={{ margin: '5px 0' }}>for accounting and taxation requirements;</li>
                <li style={{ margin: '5px 0' }}>or as otherwise required under applicable laws.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Data no longer required may be deleted or anonymized.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 13. THIRD-PARTY LINKS */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>13. THIRD-PARTY LINKS</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Our website may contain links to third-party websites or services.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We are not responsible for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>privacy practices,</li>
                <li style={{ margin: '5px 0' }}>content,</li>
                <li style={{ margin: '5px 0' }}>security,</li>
                <li style={{ margin: '5px 0' }}>or policies</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                of external websites.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users should independently review third-party policies before sharing information.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 14. USER RIGHTS */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>14. USER RIGHTS</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Subject to applicable laws, users may request:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>access to personal information;</li>
                <li style={{ margin: '5px 0' }}>correction of inaccurate data;</li>
                <li style={{ margin: '5px 0' }}>deletion of personal data;</li>
                <li style={{ margin: '5px 0' }}>withdrawal of consent;</li>
                <li style={{ margin: '5px 0' }}>discontinuation of promotional communications.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Such requests may be sent to us through the contact details mentioned below.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 15. CHILDREN’S PRIVACY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>15. CHILDREN’S PRIVACY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Our services are generally intended for students above 18 years of age.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                If a user is below 18 years, use of services shall be deemed to occur under parental or legal guardian supervision and consent.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 16. LEGAL COMPLIANCE */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>16. LEGAL COMPLIANCE</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                We may disclose information:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>if required under law,</li>
                <li style={{ margin: '5px 0' }}>pursuant to court orders,</li>
                <li style={{ margin: '5px 0' }}>government directions,</li>
                <li style={{ margin: '5px 0' }}>law enforcement investigations,</li>
                <li style={{ margin: '5px 0' }}>or regulatory requirements.</li>
              </ul>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Such disclosure may also occur to:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>protect legal rights,</li>
                <li style={{ margin: '5px 0' }}>investigate fraud,</li>
                <li style={{ margin: '5px 0' }}>enforce policies,</li>
                <li style={{ margin: '5px 0' }}>or ensure platform security.</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 17. LIMITATION OF LIABILITY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>17. LIMITATION OF LIABILITY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                While reasonable efforts are made to maintain website security and uninterrupted services, the Company shall not be liable for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '30px', margin: '5px 0' }}>
                <li style={{ margin: '5px 0' }}>technical interruptions,</li>
                <li style={{ margin: '5px 0' }}>server failures,</li>
                <li style={{ margin: '5px 0' }}>cyber attacks,</li>
                <li style={{ margin: '5px 0' }}>data loss,</li>
                <li style={{ margin: '5px 0' }}>unauthorized third-party access,</li>
                <li style={{ margin: '5px 0' }}>or events beyond reasonable control.</li>
              </ul>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 18. GOVERNING LAW & JURISDICTION */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>18. GOVERNING LAW & JURISDICTION</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                This Privacy Policy shall be governed by the laws of India.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Any dispute arising out of or relating to this Privacy Policy or website usage shall be subject to the exclusive jurisdiction of courts situated at New Delhi, India.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 19. CHANGES TO THIS PRIVACY POLICY */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>19. CHANGES TO THIS PRIVACY POLICY</h3>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                The Company reserves the right to modify or update this Privacy Policy at any time without prior notice.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Updated versions shall be posted on this page with revised effective dates.
              </p>
              <p style={{ margin: '10px 0', textAlign: 'justify' }}>
                Users are encouraged to periodically review this page.
              </p>
            </div>

            <hr style={{ border: '0', height: '1.5px', backgroundColor: '#ccc', margin: '20px 0' }} />

            {/* 20. CONTACT DETAILS */}
            <div style={{ margin: '20px 0' }}>
              <h3 style={{ fontWeight: 'bold', fontSize: '1.2vmax', margin: '15px 0 10px 0' }}>20. CONTACT DETAILS</h3>
              <p style={{ fontWeight: 'bold', margin: '5px 0', textAlign: 'justify' }}>Insight Edutech Private Limited</p>
              <p style={{ margin: '2px 0', textAlign: 'justify' }}>73, Second Floor, Main Market,</p>
              <p style={{ margin: '2px 0', textAlign: 'justify' }}>Old Rajinder Nagar,</p>
              <p style={{ margin: '2px 0', textAlign: 'justify' }}>New Delhi – 110060, India</p>
              
              <p style={{ margin: '15px 0 15px 0', textAlign: 'justify' }}>Phone:011-45090051</p>
              
              <p style={{ margin: '15px 0 15px 0', textAlign: 'justify' }}>
                Email:<a href="mailto:insightiasacademydelhi.com" style={{ color: '#0056b3', textDecoration: 'underline' }}>insightiasacademydelhi.com</a>
              </p>
              
              <p style={{ margin: '15px 0 15px 0', textAlign: 'justify' }}>
                Website: <a href="http://insightdelhi.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0056b3', textDecoration: 'underline' }}>insightdelhi.com</a>
              </p>
              
              <br />
              <p style={{ margin: '15px 0 5px 0', textAlign: 'justify' }}>
                For privacy-related concerns or requests, users may contact us through the official contact details available on the website.
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy;
